<template>
  <v-main>
    <v-container fluid style="max-width: 400px;" class="pa-0 pt-0">
      <vue-headful title="Mein Profil" description="Aimz"/>
      <user-data></user-data>
    </v-container>
  </v-main>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Vue from "vue";
import UserData from "@/views/UserData";
import CenterContainer from "@/components/CenterContainer";

export default {
  name: 'AccountProfile',
  components: {CenterContainer, UserData},
  data: () => ({}),
  mounted() {
    this.check_session();
    this.$store.commit("set", {key: "intern", value: true});
  },
  methods: {
    check_session() {

      if (!this.$app.is_logged_in) {
        if (this.$route.path != "/")
          this.$router.replace("/");
        return;
      }
    },
  },
  computed: {
    app() {
      return this.$app;
    }
  },
  watch: {
    // is_logged_in(n, o) {
    //     console.log("is_logged_in: " + n);
    //     if (!n) {
    //         this.$router.go(-1000);
    //         this.$router.replace("/")
    //     }
    // }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>